module.exports = __webpack_public_path__ + "img/rectangular-brown-wooden-dining-table-and-wooden-chairs-3229076.7a5606e9.jpg";